import { TronWeb } from 'tronweb'

/**
 * Resolve the TronWeb fullHost for the app's network. MAINNET swaps must use the MAINNET node
 * (api.trongrid.io): the mainnet USDC/USDT contracts don't exist on Nile testnet, so building a TRC-20
 * transfer there fails with "No contract or not a valid smart contract". Previously this always defaulted
 * to Nile regardless of VITE_NETWORK, which broke Tron-source swaps in mainnet mode. Exported for tests.
 */
export function resolveTronHost(network: string | undefined, override?: string): string {
  if (override) return override
  return (network || 'testnet') === 'testnet'
    ? 'https://nile.trongrid.io'
    : 'https://api.trongrid.io'
}

const TRON_RPC_URL = resolveTronHost(import.meta.env.VITE_NETWORK, import.meta.env.VITE_TRON_RPC_URL)

export const tronWeb = new TronWeb({ fullHost: TRON_RPC_URL })
